export function getStatusColor(status) {
  switch (status) {
    case 'Vereadores em Mandato':
      return '#1976D2'
    case 'Vagas Disponíveis':
      return '#2E7D32'
    case 'Veículos com Vigência a Vencer':
      return '#F57C00'
    case 'Veículos com Vigência Expirada':
      return '#C62828'
    default:
      return '#757575'
  }
}

export function getStatusGradient(status) {
  switch (status) {
    case 'Vereadores em Mandato':
      return 'linear-gradient(135deg, #1976D2, #42A5F5)'
    case 'Vagas Disponíveis':
      return 'linear-gradient(135deg, #2E7D32, #66BB6A)'
    case 'Veículos com Vigência a Vencer':
      return 'linear-gradient(135deg, #F57C00, #FFB74D)'
    case 'Veículos com Vigência Expirada':
      return 'linear-gradient(135deg, #C62828, #EF5350)'
    default:
      return 'linear-gradient(135deg, #757575, #BDBDBD)'
  }
}
